import React, { useState } from 'react';
import { Box } from '@mui/material';
import MapComponent from './Map';
import FilterPanel from './FilterPanel';
import AnalyticsPanel from './AnalyticsPanel';
import DataPanel from './DataPanel';

const InteractiveMap: React.FC = () => {
  const [isFilterPanelOpen, setFilterPanelOpen] = useState(false);
  const [isAnalyticsPanelOpen, setAnalyticsPanelOpen] = useState(false);
  const [isAnalyticsPanelMaximized, setAnalyticsPanelMaximized] = useState(false);
  const [isDataPanelOpen, setDataPanelOpen] = useState(false);
  const [isDataPanelMaximized, setDataPanelMaximized] = useState(false);

  const toggleFilterPanel = () => {
    setFilterPanelOpen(!isFilterPanelOpen);
  };

  const handleAnalyticsPanelClose = () => {
    setAnalyticsPanelOpen(false);
    setAnalyticsPanelMaximized(false);
  };

  const handleAnalyticsPanelOpen = () => {
    setAnalyticsPanelOpen(true);
  };

  const toggleAnalyticsMaximized = () => {
    setAnalyticsPanelMaximized(!isAnalyticsPanelMaximized);
  };

  const handleDataPanelClose = () => {
    setDataPanelOpen(false);
    setDataPanelMaximized(false);
  };

  const handleDataPanelOpen = () => {
    setDataPanelOpen(true);
  };

  const toggleDataPanelMaximized = () => {
    setDataPanelMaximized(!isDataPanelMaximized);
  };

  return (
    <Box sx={{ height: '100%', flexGrow: 1, width: '100%', position: 'relative', overflow: 'hidden' }}>
      <MapComponent onOpenDataPanel={handleDataPanelOpen} />

      <FilterPanel
        isOpen={isFilterPanelOpen}
        onToggle={toggleFilterPanel}
        onDataPanelOpen={handleDataPanelOpen}
        onAnalyticsPanelOpen={handleAnalyticsPanelOpen}
      />

      <AnalyticsPanel
        isOpen={isAnalyticsPanelOpen}
        isMaximized={isAnalyticsPanelMaximized}
        onClose={handleAnalyticsPanelClose}
        onMaximize={toggleAnalyticsMaximized}
      />

      <DataPanel
        isOpen={isDataPanelOpen}
        isMaximized={isDataPanelMaximized}
        onClose={handleDataPanelClose}
        onMaximize={toggleDataPanelMaximized}
      />
    </Box >
  );
};

export default InteractiveMap;